import {Component} from '@angular/core';
import {CoreService, ScannerService} from '@proleis/proleis-rest-client';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {ScannerSheetComponent} from './scanner.sheet.component';
import {CurrentViewService, NotificationService} from '@proleis/proleis-web-app';

@Component({
  selector: 'suppliers-scanner',
  templateUrl: 'scanner.component.html'
})
export class ScannerComponent {

  pending = false;

  constructor(private cs: CoreService, private ns: NotificationService, private sc: ScannerService,
              private bs: MatBottomSheet, private cvs: CurrentViewService) {
  }

  onScan(event) {
    if (!this.pending) {
      this.pending = true;
      this.openBottomSheet(event);
    }
  }

  openBottomSheet(scanEvent: string) {
    this.bs.open(ScannerSheetComponent, {data: scanEvent}).afterDismissed().subscribe(
      value => {
        if (value) {
          this.cvs.setLoading(true);
          this.sc.executeScan(scanEvent).subscribe(result => {
            if (result.message) {
              this.ns.showNotification(result.message);
            } else {
              this.ns.showNotification('Scan erfolgreich ausgeführt');
            }
            this.cvs.setLoading(false);
          }, error => {
            this.cvs.setLoading(false);
          });
        }
        this.pending = false;
      }
    );
  }
}
